import { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import ProductsPageHero from '../components/products/ProductsPageHero'
import ProductsCatalogSections from '../components/products/ProductsCatalogSections'
import ProductsValueBar from '../components/products/ProductsValueBar'
import ProductsPageCta from '../components/products/ProductsPageCta'
import SEO from '../components/common/SEO'
import {
  getFooterProductBySlug,
  scrollToCatalogTarget,
} from '../data/productsCatalogData'

function Products() {
  const { hash } = useLocation()
  const [activeCategory, setActiveCategory] = useState('all')

  const scrollToCatalog = useCallback((target) => {
    const delays = [80, 250, 500, 900, 1400]
    delays.forEach((delay) => {
      window.setTimeout(() => scrollToCatalogTarget(target, delay < 500 ? 'smooth' : 'auto'), delay)
    })
  }, [])

  useEffect(() => {
    const slug = hash.replace('#', '')
    if (!slug) return

    const product = getFooterProductBySlug(slug)
    if (!product) return

    setActiveCategory(product.categoryId)
  }, [hash])

  useEffect(() => {
    const slug = hash.replace('#', '')
    if (!slug) return

    const product = getFooterProductBySlug(slug)
    if (!product || activeCategory !== product.categoryId) return

    scrollToCatalog({
      sectionId: product.sectionId,
      itemName: product.itemName,
    })
  }, [hash, activeCategory, scrollToCatalog])

  const handleCategoryChange = useCallback((categoryId) => {
    setActiveCategory(categoryId)
    const scrollToCatalogTop = () => {
      document.getElementById('products-catalog')?.scrollIntoView({
        behavior: 'auto',
        block: 'start',
      })
    }
    window.requestAnimationFrame(scrollToCatalogTop)
    window.setTimeout(scrollToCatalogTop, 120)
    window.setTimeout(scrollToCatalogTop, 350)
  }, [])

  return (
    <>
      <SEO
        title="Products"
        description="Torbit Metals — aluminium ingots, extrusion profiles, precious metals, aluminium scrap and non-ferrous scrap for global industrial trade."
      />

      <ProductsPageHero
        activeCategory={activeCategory}
        onCategoryChange={handleCategoryChange}
      />

      <ProductsCatalogSections activeCategory={activeCategory} />

      <ProductsValueBar />

      <ProductsPageCta />
    </>
  )
}

export default Products
